import { AppError } from '@/utils/api';
import { AuthenticatedHttp } from '../../http/axios';

export const createOfferService = async (payload) => {
    try {
        const { data: response } = await AuthenticatedHttp.post('/offers/', payload);
        return response;
    } catch (error) {
        throw new AppError(error);
    }
};

export const updateOfferService = async ({ id, ...payload }) => {
    try {
        const { data: response } = await AuthenticatedHttp.put(`/offers/${id}/`, payload);
        return response;
    } catch (error) {
        throw new AppError(error);
    }
};

export const deleteOfferService = async ({ id }) => {
    try {
        const { data: response } = await AuthenticatedHttp.delete(`/offers/${id}/`);
        return response;
    } catch (error) {
        throw new AppError(error);
    }
};